import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const faqs = [
  {
    q: 'What does Gardeno do?',
    a: 'Gardeno is your pocket plant expert. Snap a photo to identify a plant, diagnose common problems like yellowing or drooping leaves, and get a personalized care plan with smart watering reminders. You can also track your whole collection in My Garden and connect with a community of fellow plant lovers.',
  },
  {
    q: 'How do I identify a plant?',
    a: 'Open the app, tap Identify, and take or upload a photo of the plant. Within seconds Gardeno gives you the species name along with its light needs, watering needs, care difficulty, and whether it is toxic to cats and dogs.',
  },
  {
    q: 'How accurate are the identifications and diagnoses?',
    a: 'Gardeno uses AI to provide identifications, diagnoses, and care suggestions for educational purposes. While we strive for accuracy, results may not always be correct. Please do not rely solely on Gardeno for decisions about plant toxicity, especially around children or pets, and always verify with an authoritative source.',
  },
  {
    q: 'How do watering reminders work?',
    a: 'When you add a plant to My Garden, Gardeno can create a reminder schedule tailored to that plant. You will receive gentle notifications when it is time to water, so your plants stay healthy through every season.',
  },
  {
    q: 'Do I need an account to use Gardeno?',
    a: 'You can use core features such as plant identification without an account. To access community features and sync your garden, you can sign in with Apple.',
  },
  {
    q: 'Is Gardeno free?',
    a: 'Gardeno offers a free tier as well as a premium subscription that unlocks the full experience. Every plan starts with a full free month. Subscriptions are billed through the Apple App Store and renew automatically unless cancelled.',
  },
  {
    q: 'How do I manage or cancel my subscription?',
    a: 'Subscriptions are managed through your Apple ID. On your iPhone, open Settings, tap your name, then Subscriptions, and select Gardeno to change or cancel your plan. Access continues until the end of your current billing period. Refunds are handled by Apple according to their policy.',
  },
  {
    q: 'Are my photos and data private?',
    a: 'We take your privacy seriously. Your photos and account information are handled as described in our Privacy Policy. You can review the details on our Privacy page.',
  },
  {
    q: 'How do I delete my account?',
    a: 'You can delete your account at any time from within the app. Deleting your account removes your saved plants and associated data. If you need help, email us and we will assist.',
  },
];

function Support() {
  return (
    <>
      <div className="legal-header">
        <div className="legal-header-inner">
          <Link to="/" style={{ fontWeight: 800, fontSize: 20, color: 'var(--primary)' }}>Gardeno</Link>
          <Link to="/" style={{ fontWeight: 600, fontSize: 14, color: 'var(--primary)' }}>Back to Home</Link>
        </div>
      </div>
      <div className="legal-content">
        <h1>Support &amp; FAQ</h1>
        <p className="updated">We are here to help you grow.</p>

        <p>Below are answers to some of the most common questions about Gardeno. If you cannot find what you are looking for, we would love to hear from you.</p>

        {faqs.map((item, i) => (
          <React.Fragment key={i}>
            <h2>{item.q}</h2>
            <p>{item.a}</p>
          </React.Fragment>
        ))}

        <h2>Still have questions?</h2>
        <p>
          If your question is not answered above, our team is happy to help. Email us and we will get back to you as soon as we can.
        </p>
        <p>
          Email: <a href="mailto:support@gardenoai.com">support@gardenoai.com</a>
        </p>
        <p>
          You may also find our <Link to="/privacy">Privacy Policy</Link> and <Link to="/terms">Terms of Service</Link> helpful.
        </p>
      </div>
      <div className="legal-footer">&copy; 2026 Gardeno. USTACK GLOBAL (SMC-PRIVATE) LIMITED. All rights reserved.</div>
    </>
  );
}

export default Support;
